import {
  CORPORATE_COMPANY,
  CORPORATE_TIMELINE,
  CORPORATE_VALUES,
} from "../CorporatePortalContent";

export default function CorporateAboutPage() {
  return (
    <>
      <section className="corporate-page-banner">
        <div className="corporate-page-banner-inner">
          <h1 className="corporate-page-banner-title">关于我们</h1>
          <p className="corporate-page-banner-desc">
            扎根上海，服务全国，用可落地的 AI 能力帮助传统行业完成数字化升级。
          </p>
        </div>
      </section>

      <div className="corporate-page">
        <section className="corporate-section" style={{ paddingTop: 40 }}>
          <h2 className="corporate-section-title">公司简介</h2>
          <p className="corporate-section-desc">{CORPORATE_COMPANY.intro}</p>
          <div className="corporate-card-grid">
            <div className="corporate-card">
              <h3 className="corporate-card-title">使命</h3>
              <p className="corporate-card-text">
                让人工智能成为每一家传统企业的「新基建」，而不是实验室里的概念验证。
              </p>
            </div>
            <div className="corporate-card">
              <h3 className="corporate-card-title">愿景</h3>
              <p className="corporate-card-text">
                成为中国领先的产业 AI 应用服务商，在 10 个重点行业形成标准化交付能力。
              </p>
            </div>
          </div>
        </section>

        <section className="corporate-section">
          <h2 className="corporate-section-title">价值观</h2>
          <div className="corporate-card-grid corporate-card-grid-3">
            {CORPORATE_VALUES.map((item) => (
              <div key={item.title} className="corporate-card">
                <h3 className="corporate-card-title">{item.title}</h3>
                <p className="corporate-card-text">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="corporate-section">
          <h2 className="corporate-section-title">发展历程</h2>
          <div className="corporate-timeline">
            {CORPORATE_TIMELINE.map((item) => (
              <div key={item.year} className="corporate-timeline-item">
                <div className="corporate-timeline-year">{item.year}</div>
                <p className="corporate-card-text">{item.event}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="corporate-section">
          <h2 className="corporate-section-title">团队与资质</h2>
          <div className="corporate-card-grid">
            <div className="corporate-card">
              <h3 className="corporate-card-title">核心团队</h3>
              <p className="corporate-card-text">
                成员来自知名互联网、工业软件与咨询机构，算法、工程与行业顾问比例约 4:4:2。
              </p>
            </div>
            <div className="corporate-card">
              <h3 className="corporate-card-title">资质认证</h3>
              <p className="corporate-card-text">
                已通过 ISO 9001 质量管理体系与 ISO 27001 信息安全管理体系认证，多项软件著作权与发明专利。
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
